import { z } from 'zod';

export const BOOKING_CANCEL_REASON_MAX_LENGTH = 500;

/**
 * Calling off a booking.
 *
 * ## The reason is optional, and there is no cancellation window
 *
 * A member who has changed their mind about meeting a stranger in person owes
 * nobody an explanation, so the field is optional and never interrogated.
 *
 * There is deliberately **no `meetings.cancellationWindowHours`** refusing a
 * late cancel. Refusing one does not stop the meeting failing — it converts a
 * cancellation the other party can *see* into a no-show they discover at the
 * venue, which is strictly worse for the person who travelled. Cancelling stays
 * always allowed; what happened is recorded on the booking's outcome, which is
 * where a pattern of late cancellations becomes visible to staff.
 *
 * `.trim()` before the length check, and a blank string is refused rather than
 * stored: "  " is not a reason, and storing it would draw an empty quotation
 * mark on the other member's card.
 */
export const BookingCancelSchema = z
  .object({
    reason: z.string().trim().min(1).max(BOOKING_CANCEL_REASON_MAX_LENGTH).optional(),
  })
  .strict();

export type BookingCancelRequest = z.infer<typeof BookingCancelSchema>;
